import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
} from "@mui/material";

interface Props {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
    title: string;
    message: string;
}

const ConfirmationModal: React.FC<Props> = ({
                                                isOpen,
                                                onClose,
                                                onConfirm,
                                                title,
                                                message,
                                            }) => {
    return (
        <Dialog
            open={isOpen}
            onClose={onClose}
            maxWidth="xs"
            fullWidth
            PaperProps={{
                style: {
                    borderRadius: "12px",
                    padding: "12px",
                }
            }}
        >
            <DialogTitle sx={{ fontWeight: 700, fontSize: "22px", textAlign: "center", color: "#1a1a1a" }}>
                {title}
            </DialogTitle>
            <DialogContent sx={{ padding: "20px 24px" }}>
                <Typography sx={{ fontSize: "16px", color: "#555", textAlign: "center" }}>
                    {message}
                </Typography>
            </DialogContent>
            <DialogActions sx={{ justifyContent: "center", paddingBottom: "24px", gap: "16px" }}>
                {/* Cancel Button */}
                <Button
                    variant="outlined"
                    onClick={onClose}
                    sx={{
                        width: "120px",
                        fontWeight: 600,
                        color: "#6b6b6b",
                        borderColor: "#bbb",
                        "&:hover": {
                            borderColor: "#999",
                            backgroundColor: "#f0f0f0",
                            color: "#333",
                        }
                    }}
                >
                    Cancel
                </Button>

                {/* Confirm Button */}
                <Button
                    variant="contained"
                    onClick={onConfirm}
                    sx={{
                        width: "140px",
                        fontWeight: 600,
                        color: "#fff",
                        backgroundColor: "#e53935",  // brighter red
                        "&:hover": {
                            backgroundColor: "#c62828", // darker red on hover
                        }
                    }}
                >
                    Confirm
                </Button>
            </DialogActions>

        </Dialog>
    );
};

export default ConfirmationModal;
